import { render, staticRenderFns } from "./RolePageView.vue?vue&type=template&id=65957507&scoped=true"
import script from "./RolePageView.vue?vue&type=script&lang=js"
export * from "./RolePageView.vue?vue&type=script&lang=js"
import style0 from "./RolePageView.vue?vue&type=style&index=0&id=65957507&prod&scoped=true&lang=css"
import style1 from "./RolePageView.vue?vue&type=style&index=1&id=65957507&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65957507",
  null
  
)

export default component.exports